import { render, staticRenderFns } from "./CMSMailEditor.vue?vue&type=template&id=3a591979&"
import script from "./CMSMailEditor.vue?vue&type=script&lang=js&"
export * from "./CMSMailEditor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports